import { createAction } from "@reduxjs/toolkit";

// Action types
export const SERVER_VALIDATION_SET = '[SERVER_VALIDATIONS] Setting server validations';
export const SERVER_VALIDATION_RESET = '[SERVER_VALIDATIONS] Resetting server validations';

// Actions
export const serverValidationSet = createAction(SERVER_VALIDATION_SET);
export const serverValidationReset = createAction(SERVER_VALIDATION_RESET);